import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { iconList as icons } from 'assets/index';

const getNextDirection = (current) => {
  if (current === 'asc') return 'desc';
  if (current === 'desc') return null;
  return 'asc';
};

const ColumnSort = ({ direction, onSort, disabled }) => (
  <button
    type="button"
    onClick={() => !disabled && onSort(getNextDirection(direction))}
    style={{ background: 'none', border: 'none', padding: 0, marginLeft: 4, cursor: disabled ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center' }}
    disabled={disabled}
    title={direction ? `Sort ${direction}` : 'Sort'}
  >
    <ReactSVG src={icons.sort} style={{ width: 14, height: 14, opacity: direction ? 1 : 0.5, transform: direction === 'desc' ? 'rotate(180deg)' : 'none', fill: '#fff' }} />
  </button>
);

ColumnSort.propTypes = {
  direction: PropTypes.oneOf(['asc', 'desc', null]),
  onSort: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ColumnSort.defaultProps = {
  direction: null,
  disabled: false,
};

export default ColumnSort; 